import Timer from "../../../../src/blog/stop-the-time-with-cyclock/Timer.js";
import * as React from 'react';
export default {
  Timer,
  React
};